import { useAppDispatch } from "src/redux";

type tUseToast = (params: { description: string; status?: "success" | "error" }) => void;

export const useToast = (): tUseToast => {
  const dispatch = useAppDispatch();
  return ({ description, status = "success" }) => {
    dispatch({ type: "RIBBON", message: status === "error" ? new Error(description) : description });
  };
};
